var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadMoreArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 573"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 22",
    cx: 29,
    cy: 29,
    r: 29,
    fill: "#F15D36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 27L29 37L39 27",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadMoreArrow);
export default __webpack_public_path__ + "static/media/load-more-arrow.7dd2c4ede71dc632d2472a4523bdd290.svg";
export { ForwardRef as ReactComponent };